import { useCallback } from "react";
import { useToast } from "@/v2/ui";

type ToastVariant = "success" | "error" | "warning" | "info" | "default";

export const useShowToast = () => {
  const { toast } = useToast();

  return useCallback(
    (message: string, appearance?: string) => {
      const variantMap: Record<string, ToastVariant> = {
        success: "success",
        error: "error",
        warning: "warning",
        info: "info",
      };
      toast(message, variantMap[appearance || ""] || "default");
    },
    [toast]
  );
};
